const Immutable = require('seamless-immutable');

module.exports = {
	doing(inProgressState, state) {
		return state.set(inProgressState, true);
	},

	did(inProgressState, state, action) {
		state = state.set(inProgressState, false);
		if (!action.payload.error) {
			state = state.set('list', Immutable(action.payload.list));
		}
		return state;
	}
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/reducers/common.js